// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification_Notification___Z6NK"};